import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { history } from '../../../_services/essentials/helpers';
import { userActions, alertActions } from '../../../_services/essentials/store';
import { UserAgreement } from './UserAgreement'
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Button, Grid, TextField, Box, Stack, Typography, Paper, InputAdornment, Checkbox } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ArrowForwardOutlined } from '@mui/icons-material';

export { Register };

function Register() {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    // form validation rules
    const validationSchema = Yup.object().shape({
        firstname: Yup.string()
            .required('First Name is required'),
        lastname: Yup.string()
            .required('Last Name is required'),
        email: Yup.string().email("Please enter a valid Email")
            .required('Email is required'),
        password: Yup.string()
            .required('Password is required')
            .min(6, 'Password must be at least 6 characters')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;

    const [agreementSigned, setAgreementSigned] = useState(false);
    const [agreementPage, setAgreementPage] = React.useState(false);

    const handleClickAgreementPageOpen = () => {
        setAgreementPage(true);
    };

    const handleAgreementPageClose = () => {
        setAgreementPage(false);
    };


    async function onSubmit(data) {
        dispatch(alertActions.clear());

        try {
            const response = await dispatch(userActions.register(data)).unwrap();
            if (response === "New user account registered successfully. We will contact you to complete the account activation.") {
                // redirect to login page and display success alert
                history.navigate('/account/login');
                dispatch(alertActions.success({ message: response, showAfterRedirect: true }));
            }
            else { dispatch(alertActions.error({ message: response })); }
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    // const Card = styled(MuiCard)(({ theme }) => ({
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignSelf: 'center',
    //     width: '100%',
    //     padding: theme.spacing(4),
    //     gap: theme.spacing(2),
    //     margin: 'auto',
    //     boxShadow:
    //         'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    //     [theme.breakpoints.up('sm')]: {
    //         width: '80%',
    //         maxWidth: '500px'
    //     },
    //     ...theme.applyStyles('dark', {
    //         boxShadow:
    //             'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    //     }),
    // }));

    return (
        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: { md: 'flex-end' } }}>
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    maxWidth: '380px',
                    p: { xs: 2, md: 2 },
                    borderRadius: 4,
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '580px',
                    alignContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Stack
                    sx={{
                        justifyContent: 'space-between', flexGrow: '1', gap: 1
                    }}
                >
                    <Typography variant="h5" component="h3" sx={{ fontWeight: 700, color: '#1a1068', mb: 0.5 }}>
                        Sign Up
                    </Typography>
                </Stack>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stack
                        sx={{
                            // minWidth: '900px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            px: 2
                        }}
                    >

                        <Box sx={{
                            justifyContent: 'space-between', width: '100%', maxWidth: '350px', mt: 2
                        }}                    >
                            <FormControl fullWidth>
                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>First name*
                                </Typography>
                                <TextField
                                    id="firstname"
                                    name="firstname"
                                    type="text"
                                    autoFocus
                                    fullWidth
                                    placeholder=""
                                    autoComplete="off"
                                    defaultValue={""}
                                    variant="outlined"
                                    slotProps={{
                                        input: {
                                            sx: {
                                                mb: 2,
                                                bgcolor: '#ffffff',
                                                borderRadius: 2,
                                                height: '40px',
                                                maxWidth: '350px',
                                                width: '100%'
                                            }
                                        }
                                    }}
                                    {...register('firstname', { required: true })}
                                    error={Boolean(errors.firstname)}
                                    helperText={errors.firstname ? errors.firstname.message : ""}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Last name*
                                </Typography>
                                <TextField
                                    id="lastname"
                                    name="lastname"
                                    type="text"
                                    fullWidth
                                    placeholder=""
                                    autoComplete="off"
                                    defaultValue={""}
                                    slotProps={{
                                        input: {
                                            sx: {
                                                mb: 2,
                                                bgcolor: '#ffffff',
                                                borderRadius: 2,
                                                height: '40px',
                                                maxWidth: '350px',
                                                width: '100%'
                                            }
                                        }
                                    }}
                                    {...register('lastname', { required: true })}
                                    error={Boolean(errors.lastname)}
                                    helperText={errors.lastname ? errors.lastname.message : ""}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Email*
                                </Typography>
                                <TextField
                                    id="email"
                                    name="email"
                                    type="text"
                                    fullWidth
                                    placeholder=""
                                    autoComplete="off"
                                    variant="outlined"
                                    defaultValue={""}
                                    slotProps={{
                                        input: {
                                            sx: {
                                                mb: 2,
                                                bgcolor: '#ffffff',
                                                borderRadius: 2,
                                                height: '40px',
                                                maxWidth: '350px',
                                                width: '100%'
                                            }
                                        }
                                    }}
                                    {...register('email', { required: true })}
                                    error={Boolean(errors.email)}
                                    helperText={errors.email ?
                                        errors.email.message : ""}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Password*
                                </Typography>
                                <TextField
                                    fullWidth
                                    id="password"
                                    name="password"
                                    // type="password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder=""
                                    autoComplete="off"
                                    variant="outlined"
                                    defaultValue={""}
                                    slotProps={{
                                        input: {
                                            sx: {
                                                mb: 2,
                                                bgcolor: '#ffffff',
                                                borderRadius: 2,
                                                height: '40px',
                                                maxWidth: '350px',
                                                width: '100%'
                                            }
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <div
                                                    style={{
                                                        cursor: 'pointer',
                                                        height: '24px'
                                                    }}
                                                    onClick={handleTogglePassword}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </div>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...register('password', { required: true })}
                                    error={Boolean(errors.password)}
                                    helperText={errors.password ? errors.password.message : ""}
                                />
                            </FormControl>

                            <FormControlLabel sx={{ mb: 1 }}
                                control={
                                    <>
                                        <Checkbox value={"Agreemenmt"} checked={agreementSigned} color="primary" onClick={() => setAgreementSigned(!agreementSigned)} />
                                        <Typography
                                            component="h1"
                                            variant="h6"
                                            sx={{ width: '100%', fontSize: '14px' }}
                                        >
                                            I agree to the <Link onClick={() => handleClickAgreementPageOpen()} variant="body2" sx={{ alignSelf: 'center' }}> terms and conditions </Link>.
                                        </Typography>
                                    </>
                                }
                            />
                            <UserAgreement open={agreementPage} handleAgreementPageClose={handleAgreementPageClose}
                                setAgreementSigned={setAgreementSigned} />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                disabled={!agreementSigned}
                                endIcon={<ArrowForwardOutlined />}
                                sx={{
                                    borderRadius: '16px', width: '100%', textTransform: 'uppercase',
                                    fontWeight: '500', fontSize: '18px', maxWidth: '350px', mb: 2, height: '40px'
                                }}
                            >
                                Sign up
                            </Button>

                            <Typography sx={{ textAlign: 'center' }}>
                                Already have an account?{' '}
                                <Link
                                    to="/account/login"
                                    variant="body2"
                                    sx={{ alignSelf: 'center' }}
                                >
                                    Sign in
                                </Link>
                            </Typography>
                        </Box>
                    </Stack>
                </form>
            </Paper>
        </Grid>

    )
}
